import { Divider } from '@atoms'

import GroupAddress from '../../list-groups/GroupAddress'
import PointPeople from '../../list-groups/PointPeople'
import { GroupDetailsPanel } from '../../list-groups/GroupDetailsPanel'

type Props = {
  description: string | null
  streetAddress: string | null
  city: string | null
  state: string | null
  postcode: string | null
  notifyAllAdmins: boolean
  pointPeople: string[]
}
function GroupDetailsPreview({
  description,
  streetAddress,
  city,
  state,
  postcode,
  notifyAllAdmins,
  pointPeople,
}: Props) {
  const hasAddress = streetAddress ?? city ?? state ?? postcode
  return (
    <div className="tw:flex tw:flex-col tw:gap-3 tw:pt-2">
      {description && <p>{description}</p>}
      {hasAddress && <GroupAddress streetAddress={streetAddress} city={city} postcode={postcode} state={state} />}
      <GroupDetailsPanel>
        <PointPeople notifyAllAdmins={notifyAllAdmins} pointPersonEmails={pointPeople} />
      </GroupDetailsPanel>
      <div className="tw:py-3">
        <Divider />
      </div>
    </div>
  )
}

export default GroupDetailsPreview
